import React, { useState } from 'react';

export default function ContactForm() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [description, setDescription] = useState('');
  const [callTime, setCallTime] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetFields = () => {
    setName('');
    setEmail('');
    setPhone('');
    setDescription('');
    setCallTime('');
  };

  const validateFields = () => {
    if (!name || !email || !phone || !description || !callTime) {
      alert('All fields are mandatory');
      return false;
    }
    return true;
  };

  const submitHandler = async () => {
    if (!validateFields()) return;

    setIsSubmitting(true);
    const formData = { name, email, phone, description, callTime };

    try {
      const response = await fetch('https://jdts.kvrwears.com/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      alert('Email sent Successfully');
      resetFields();
      await databaseManager(formData);
    } catch (error) {
      alert('Please enter a registered email or check your input');
    } finally {
      setIsSubmitting(false);
    }
  };

  const databaseManager = async (formData) => {
    try {
      const response = await fetch('https://jdtechnicalsolution.com/form/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to send data to database');
      }

      console.log("Data sent successfully");
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  return (
    <form>
      <div className="row g-1">
        <div className="col-md-6">
          <div className="form-floating">
            <input
              type="text"
              className="form-control border"
              id="name"
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label htmlFor="name">Your Name</label>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating">
            <input
              type="email"
              className="form-control border"
              id="email"
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="email">Your Email</label>
          </div>
        </div>
        <div className="col-12">
          <div className="form-floating">
            <input
              type="text"
              className="form-control border"
              id="phone"
              placeholder="Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
            <label htmlFor="phone">Phone Number</label>
          </div>
        </div>
        <div className="col-12">
          <div className="form-floating">
            <select
              className="form-select border"
              id="callTime"
              value={callTime}
              onChange={(e) => setCallTime(e.target.value)}
            >
              <option value="">Schedule Callback</option>
              <option value="9am to 11am">9am to 11am</option>
              <option value="11am to 1pm">11am to 1pm</option>
              <option value="1pm to 3pm">1pm to 3pm</option>
              <option value="3pm to 5pm">3pm to 5pm</option>
            </select>
            {/* <label htmlFor="callTime">Schedule Call</label> */}
          </div>
        </div>
        <div className="col-12">
          <div className="form-floating">
            <textarea
              className="form-control border"
              placeholder="Leave a message here"
              id="message"
              style={{ height: "160px" }}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <label htmlFor="message">Brief description of your business...</label>
          </div>
        </div>
        <div className="col-12 text-center">
          <button
            className="btn btn-primary w-100"
            type="button"
            onClick={submitHandler}
            disabled={isSubmitting}
          >
            <p className="py-1 mb-0">
              {isSubmitting ? 'Scheduling...' : 'Schedule A Callback'}
            </p>
          </button>
        </div>
      </div>
    </form>
  );
}


